import { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { useSetRecoilState } from 'recoil';
import theme from './styles/Theme';
import GlobalStyle from './styles/GlobalStyle';
import Router from './routes/Router';
import ScrollTopButton from './components/Button/ScrollTopButton';
import { supabase } from './lib/supabase';
import { isAdminState } from './recoil/atoms';

function App() {
  const setIsAdmin = useSetRecoilState(isAdminState);

  // 새로고침해도 로그인 상태가 유지되도록 세션을 복구한다
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setIsAdmin(!!data.session);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAdmin(!!session);
    });

    return () => listener.subscription.unsubscribe();
  }, [setIsAdmin]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router />
      <ScrollTopButton />
    </ThemeProvider>
  );
}

export default App;
